import { apiClient } from './client';

export interface BillingPreview {
  effective_tier: string;
  active_child_count: number;
  minimum_children: number;
  starting_monthly_zar: number;
  starting_annual_zar: number;
  per_child_monthly_zar: number;
  per_child_annual_zar: number;
  projected_monthly_zar: number;
  projected_annual_zar: number;
  is_trial: boolean;
  trial_ends_at: string | null;
  /** 'free' | 'per-child' | 'legacy' */
  billing_model: string;
  paystack_configured: boolean;
}

export const billingApi = {
  async getCurrentBilling(): Promise<BillingPreview> {
    const response = await apiClient.get<BillingPreview>('/organizations/current/billing');
    return response.data;
  },
};
